import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

interface LearningProgress {
  _id: string;
  examScorePercent: number;
}

interface ExamScoresState {
  learningProgresses: LearningProgress[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: ExamScoresState = {
  learningProgresses: [],
  status: 'idle',
};

const examScoresSlice = createSlice({
  name: 'examScores',
  initialState,
  reducers: {
    setExamScore: (state, action: PayloadAction<{ _id: string; score: number }>) => {
      const existing = state.learningProgresses.find(lp => lp._id === action.payload._id);
      if (existing) {
        existing.examScorePercent = action.payload.score || -100;
      } else {
        state.learningProgresses.push({
          _id: action.payload._id,
          examScorePercent: action.payload.score || -100,
        });
      }
    },
    resetExamScores: () => initialState,
    setStatus: (state, action: PayloadAction<ExamScoresState['status']>) => {
      state.status = action.payload;
    },
  },
});

export const selectExamScores = (state: RootState) => state.examScores.learningProgresses;
export const { setExamScore, resetExamScores, setStatus } = examScoresSlice.actions;
export default examScoresSlice.reducer;
